import { render, staticRenderFns } from "./UserDetailsModal.vue?vue&type=template&id=63c32d5c&scoped=true"
import script from "./UserDetailsModal.vue?vue&type=script&lang=ts"
export * from "./UserDetailsModal.vue?vue&type=script&lang=ts"
import style0 from "./UserDetailsModal.vue?vue&type=style&index=0&id=63c32d5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c32d5c",
  null
  
)

export default component.exports